import { render, staticRenderFns } from "./binsFormPage.vue?vue&type=template&id=175f71fb&scoped=true&"
import script from "./binsFormPage.vue?vue&type=script&lang=js&"
export * from "./binsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./binsFormPage.vue?vue&type=style&index=0&id=175f71fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f71fb",
  null
  
)

export default component.exports